var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowReviewBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13.04 13.424c-.6.36-1.302.568-2.052.568a4 4 0 0 1-3.868-2.999H3.342l2.372 2.31c.176.176.283.42.283.694 0 .537-.452.998-.988.998a.935.935 0 0 1-.691-.289L.292 10.683A.96.96 0 0 1 0 9.999c0-.274.107-.518.283-.694l4.035-4.04a.973.973 0 0 1 .691-.288c.536 0 .988.47.988 1.007a.975.975 0 0 1-.283.694L3.332 8.984h3.786a4 4 0 0 1 3.87-3.006c.771 0 1.492.22 2.102.599l3.565-3.57-2.538-.003a.974.974 0 0 1-.69-.29c-.38-.38-.38-1.052-.002-1.431A.94.94 0 0 1 14.122 1l4.896.005a.96.96 0 0 1 .69.277c.193.193.27.442.27.69l.005 4.9a.971.971 0 0 1-.289.69 1.023 1.023 0 0 1-1.416 0 .975.975 0 0 1-.29-.691l-.003-2.54-3.554 3.62c.351.596.553 1.291.553 2.034 0 .763-.213 1.477-.583 2.084l3.595 3.595.003-2.54c0-.249.097-.497.29-.69.38-.38 1.05-.381 1.429-.002a.94.94 0 0 1 .282.697l-.005 4.9a.927.927 0 0 1-.277.675.974.974 0 0 1-.69.291L13.974 19a.97.97 0 0 1-.69-.29 1.03 1.03 0 0 1 .002-1.42.974.974 0 0 1 .69-.29l2.696-.003-3.632-3.573Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowReviewBranch);
export default __webpack_public_path__ + "static/media/flow-review-branch.3858f0069c5314c9af72aedcfc9b60f2.svg";
export { ForwardRef as ReactComponent };